export default "__VITE_ASSET__BRmUFL5o__"